export class Homepage {
  titel:string | undefined;
  welkom:string | undefined;
  vestigingen_intro:string | undefined;
}
